export default "__VITE_ASSET__DqQQ3WOi__"